import { apiSlice } from "../api-slice";
import { setCredentials } from "../../features/auth/auth-slice";
import { store } from "../store";
import { LoginCredentials } from "../../features/auth/auth-state";
import { LoginResponse, RefreshTokenResponse, VerifyOTPRequest, VerifyOTPResponse } from "./auth-api-state";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation<LoginResponse, LoginCredentials>({
            query: (credentials) => ({
                url: '/api/user/login',
                method: 'POST',
                body: credentials
            })
        }),
        refreshToken: builder.mutation<RefreshTokenResponse, void>({
            query: () => ({
                url: '/api/user/refresh-token',
                method: 'POST',
            }),
            transformResponse: (response: RefreshTokenResponse) => {
                store.dispatch(setCredentials({
                    accessToken: response.accessToken,
                    refreshToken: "",
                    status: response.status,
                    user: response.user
                }));
                return response; 
            },
            invalidatesTags: ["User"], 
        }),
        verifyOTP: builder.mutation<VerifyOTPResponse, VerifyOTPRequest>({
            query: (data) => ({
                url: '/api/user/verify-otp',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ["User"], 
        }),
        logOut: builder.mutation<void, { email: string }>({
            query: ({ email }) => ({
                url: '/api/user/logout',
                method: 'POST',
                body: { email },
            }),
        }),
        resendOTP: builder.mutation<Response, { email: string }>({
            query: ({ email }) => ({
                url: '/api/user/resend-otp',
                method: 'POST',
                body: { email },
            }),
        }),
    })
})

export const {
    useLoginMutation,
    useRefreshTokenMutation,
    useVerifyOTPMutation,
    useLogOutMutation,
    useResendOTPMutation,
} = authApiSlice;